import { useEffect, useState } from 'react';

const QUERY = '(prefers-reduced-motion: reduce)';

// Visitors who ask their OS to reduce motion shouldn't be handed autoplaying
// loops. CSS covers the animations; this covers the video elements, which CSS
// can't stop on its own.
export default function usePrefersReducedMotion() {
  const [reduced, setReduced] = useState(
    () => typeof window !== 'undefined'
      && typeof window.matchMedia === 'function'
      && window.matchMedia(QUERY).matches
  );

  useEffect(() => {
    if (typeof window.matchMedia !== 'function') return undefined;

    const mql = window.matchMedia(QUERY);
    const onChange = () => setReduced(mql.matches);
    setReduced(mql.matches);

    // Safari below 14 only has the deprecated addListener.
    if (mql.addEventListener) {
      mql.addEventListener('change', onChange);
      return () => mql.removeEventListener('change', onChange);
    }
    mql.addListener(onChange);
    return () => mql.removeListener(onChange);
  }, []);

  return reduced;
}
